<template>
  <div>
    <div
      :style="renderImageUrl"
      class="w-100"
      :class="
        `${vertical ? 'image-area-vertical' : 'image-area'} ${
          uploadImage.url ? 'preview-image' : null
        }`
      "
    />
  </div>
</template>

<script>
import { computed, reactive } from "@vue/composition-api";
import imgDefault from "@/assets/images/icons/img.svg";

export default {
  props: {
    imageUrl: { type: [Object, String]},
    vertical: { type: Boolean, default: false },
  },
  setup(props) {
    const uploadImage = reactive({ file: null, url: props.imageUrl || null });

    const renderImageUrl = computed(() => {
      uploadImage.url = props.imageUrl;

      let img = uploadImage.url || imgDefault;
      img = img.replaceAll(" ", "%20");

      return {
        "background-image": `url(${img})`,
      };
    });

    return {
      renderImageUrl,
      uploadImage,
    };
  },
};
</script>

<style scoped>
.image-area {
  width: 100%;
  height: 130px;
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: center;
  /* background-color: #f8f8f8; */
  background-color: #ffffff;
  border: 1.5px dashed #e0e0e0;
  cursor: default;
  border-radius: 1px;
  cursor: default;
}

.image-area-vertical {
  width: 100%;
  height: 130px;
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: center;
  /* background-color: #f8f8f8; */
  background-color: #ffffff;
  border: 1.5px dashed #e0e0e0;
  border-radius: 1px;
  cursor: default;
}

.preview-image {
  background-size: cover;
  border: none;
}
</style>
